"use client";

import React, { useState } from "react";
import Accordion from "@motorata/base-ui.components.molecules.accordion";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import { H3, Label } from "@motorata/base-ui.components.atoms.typography";
import Link from "@motorata/next.components.atoms.link";
import Icon from "@motorata/base-ui.components.atoms.icon";
import NextLink from "next/link";
import CalculationBlock from "@motorata/base-ui.components.shared.calculation-block";
import Button from "@motorata/base-ui.components.atoms.button";
import InfoBlock from "@motorata/next.components.shared.info-block";
import { CalculateParamsType, CalculateType } from "@motorata/base-ui.types.api";
import { addSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string";
import MotoUpCalculatorBlock from "../../components/shared/MotoUpCalculatorBlock";
import MapBlock from "../../components/shared/MapBlock";
import Image from "../../components/common/Image";
import SuccessModal from "../../components/modals/SuccessModal";
import OfferModalMessage from "./OfferModalMessage";
import OfferModalLead, { OfferModalLeadPhoneVerify } from "./OfferModalLead";
import OfferModalVerify from "./OfferModalVerify";

const OfferSideBar = ({ id, type, brand, model, finance, profile, year, client }) => {
  const [calculation, setCalculation] = useState<CalculateType | null>(null);
  const [calculationParams, setCalculationParams] = useState<CalculateParamsType | null>(null);
  const [modal, setModal] = useState<string | null>();
  const [lead, setLead] = useState();

  const { price, grossPrice } = finance;

  return (
    <>
      <Box>
        <Accordion title="Twoje finansowanie" wrapperProps={{
          marginBottom: "S"
        }}>
          <CalculationBlock initParams={{ price: grossPrice }} year={year} showValueSlider={false}
                            onChangeCalculation={setCalculation} onChangeParams={setCalculationParams} additionalData={{
            "Rodzaj faktury": finance.invoice
          }} allowFinances={{
            leasing: finance.invoice === "vat",
            credit: true
          }} />
          <Box marginTop="M">
            {
              profile &&
              <Button
                type="secondary"
                width="100%"
                icon="message"
                margin="0 0 10px"
                onClick={() => setModal("message")}
              >
                Wyślij wiadomość
              </Button>
            }
            <Button icon="send" width="100%" onClick={() => setModal("lead")}>
              Otrzymaj bezpłatną ofertę
            </Button>
          </Box>
        </Accordion>
        <InfoBlock img="/images/isAvailable.png" color="green" label="Od ręki" title="Sprawdź dostępność samochodu"
                   text="Chcesz się upewnić czy samochód jest dostępny u sprzedawcy lub zadać dodatkowe pytania?"
                   marginBottom="S">
          <Button width="100%" background="green" hoverBackground="greenDarker"
                  onClick={() => setModal("verify")} marginTop="S">
            Sprawdź dostępność
          </Button>
        </InfoBlock>
        {
          profile &&
          <Accordion title="Informacje o profilu" wrapperProps={{
            marginBottom: "S"
          }}>
            <Row>
              {profile.images.profile && (
                <Row
                  background="background"
                  marginRight="1rem"
                  width="80px"
                  minWidth="80px"
                  height="80px"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="50%"
                  overflow="hidden"
                >
                  <Image
                    width={80}
                    height={80}
                    alt={`Zdjęcie profilowe ${profile.name}`}
                    src={profile.images.profile.src}
                    size={250}
                    style={{
                      objectFit: "contain"
                    }}
                  />
                </Row>
              )}
              <Box width="100%">
                <Row>
                  <Icon width="15px" minWidth="15px" marginRight="XS" icon="verified-fill" color="blue" />
                  <H3 margin="0">
                    {profile.name}
                  </H3>
                </Row>
                <Label type="third" icon="location-fill" marginBottom="S">
                  {profile.address.city}
                </Label>
                <Link type="secondary" width="100%" href={`/${profile.slug}`}>
                  Profil użytkownika
                </Link>
              </Box>
            </Row>
          </Accordion>
        }
        {
          client &&
          <Accordion title="Informacje o użytkowniku" wrapperProps={{
            marginBottom: "S"
          }}>
            <Box width="100%">
              <H3 margin="0" marginBottom="XXS">
                {`${client.firstName} ${client.lastName}`}
              </H3>
              <NextLink href={`mailto:${client.email}`}>
                <Label type="third" icon="email" marginBottom="S">
                  {client.email}
                </Label>
              </NextLink>
              <Link width="100%" href={`tel:${client.phone}`} type="secondary" icon="phone-fill">
                {addSpacesFromPhoneNumber(client.phone)}
              </Link>
            </Box>
          </Accordion>
        }
        {
          profile &&
          <Accordion padding="0" wrapperProps={{
            marginBottom: "S"
          }}>
            <MapBlock height="300px" address={profile.address} />
          </Accordion>
        }
        {/*<InfoBlock img="/images/key.png" label="Wynajem krótkoterminowy" title="Potrzebujesz samochodu na już?" text="Posiadamy samochody przekontraktowe, z których możesz korzystać aż do przyjazdu Twojego*/}
        {/*  wymarzonego samochodu!" />*/}
        <MotoUpCalculatorBlock />
        <OfferModalMessage
          id={id} type={type} brand={brand} model={model} profile={profile}
          show={modal === "message"}
          setShow={setModal}
        />
        <OfferModalLead
          id={id} type={type} brand={brand} model={model} profile={profile} client={client}
          currentModal={modal}
          calculation={calculation}
          calculationParams={calculationParams}
          setLead={setLead}
          show={modal === "lead"}
          setShow={setModal}
        />
        <OfferModalVerify
          id={id} type={type} brand={brand} model={model} profile={profile}
          show={modal === "verify"}
          setShow={setModal}
        />
        <OfferModalLeadPhoneVerify
          id={id} type={type} brand={brand} model={model} profile={profile} client={client}
          lead={lead}
          currentModal={modal}
          show={modal === "lead-phone-verify"}
          setShow={setModal}
        />
        <SuccessModal show={modal === "success"} setShow={setModal} />
      </Box>
    </>
  );
};

export default OfferSideBar;
